import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { StaticDateRangePickerProps } from '@mui/x-date-pickers-pro/StaticDateRangePicker';
import { colors } from '../../../../styles/color-tokens';
import 'dayjs/locale/nb';
import { DateRangePicker } from '@mui/x-date-pickers-pro';
import { MdDateRange } from 'react-icons/md';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RangeShortcuts } from './range-shortcuts';
import { shortcutsItems } from './shortcuts';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { selectSessionLanguage } from '../../../../redux/session/session.slice';
import { DateRangePickerSlots } from '@mui/x-date-pickers-pro/DateRangePicker';
import { InputProps } from '@mui/material';
import { PickerRangeValue } from '@mui/x-date-pickers/internals/models';
import { Dayjs } from 'dayjs';
interface DatePickerWithShortcutsProps extends StaticDateRangePickerProps {
  selectedDate?: PickerRangeValue;
  InputProps?: InputProps;
  onSelected?: (value: PickerRangeValue) => void;
  onClose?: () => void;
  maxDate?: Dayjs;
}

export default function DateRangePickerWithShortcuts(props: DatePickerWithShortcutsProps) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('global');
  const sessionLanguage = useAppSelector(selectSessionLanguage);
  const locale = sessionLanguage || 'no';

  const handleClick = () => {
    setOpen(!open);
  };

  const slots: Partial<DateRangePickerSlots> = {
    shortcuts: RangeShortcuts,
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
      <DateRangePicker
        open={open}
        maxDate={props.maxDate}
        onClose={() => {
          setOpen(false);
          props.onClose?.();
        }}
        format="DD. MMM YYYY"
        value={props.selectedDate || undefined}
        slots={slots}
        slotProps={{
          textField: {
            size: 'small',
            onClick: () => {
              setOpen(true);
            },
            InputProps: props?.InputProps ?? {
              startAdornment: <MdDateRange className="text-brand-primary hover:cursor-pointer" onClick={handleClick} />,
              endAdornment: <></>,
            },
            sx: {
              '& .MuiPickersInputBase': {
                color: 'white',
              },
              '& .MuiPickersInputBase-activeBar': {
                backgroundColor: colors.primary.main,
              },
              '& .MuiPickersOutlinedInput-root': {
                backgroundColor: colors.background.surface.elevated,
                borderRadius: '6px',
                gap: '8px',
                width: 'fit-content',
                color: 'white',
                '& .MuiPickersInputBase-sectionsContainer': {
                  width: 'fit-content',
                  minWidth: 'auto',
                },
                '& .MuiPickersSectionList-root': {
                  width: 'fit-content',
                  minWidth: 'auto',
                },
                '& .MuiPickersSectionList-sectionContent, & .MuiPickersInputBase-sectionAfter, & .MuiPickersInputBase-sectionBefore':
                  {
                    fontSize: '14px',
                  },
                '& .MuiPickersOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&:hover .MuiPickersOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '&.Mui-focused .MuiPickersOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .MuiPickersInputBase-input': {
                  color: 'white',
                },
                '& .MuiPickersInputBase-sectionAfter': {
                  color: 'white',
                },
                '& .MuiPickersInputBase-sectionBefore': {
                  color: 'white',
                },
              },
            },
          },
          shortcuts: {
            items: shortcutsItems(t),
          },
          openPickerButton: {
            color: 'primary',
          },
          toolbar: {
            hidden: true,
          },
          actionBar: {
            hidden: true,
          },
          layout: {
            sx: {
              color: colors.text.primary,
              backgroundColor: colors.background.surface.base,
              '& .MuiDayCalendar-header': {
                '& .MuiDayCalendar-weekDayLabel': {
                  color: '#C2B1A0',
                },
              },
              '& .MuiDateRangePickerDay-hiddenDayFiller': {
                backgroundColor: 'transparent !important',
              },
              '& .MuiDateRangePickerDay-rangeIntervalDayHighlight': {
                backgroundColor: '#2C2925',
              },
              '& .MuiDateRangePickerDay-day:focus.Mui-selected': {
                backgroundColor: colors.primary.main,
              },
              '& .MuiDayCalendar-day': {
                color: colors.text.primary,
              },
              '& .MuiPickersDay-root': {
                color: colors.text.primary,
              },
              '& .MuiPickersCalendarHeader-label': {
                color: colors.text.primary,
              },
              '& .MuiPickersCalendarHeader-switchHeader button': {
                color: colors.text.primary,
              },
              '& .MuiDateRangePickerDay-day.Mui-selected': {
                backgroundColor: colors.primary.main,
                color: colors.background.base,
              },
              '& .MuiDateRangePickerDay-day.Mui-selected:hover': {
                backgroundColor: colors.primary.hover,
                color: colors.background.base,
              },
              '& .MuiButtonBase-root-MuiPickersDay-root-MuiDateRangePickerDay-day.Mui-selected': {
                color: colors.text.primary,
                backgroundColor: colors.primary.main,
              },
              '& .MuiPickersDay-today': {
                border: `1px solid ${colors.primary.main} !important`,
              },
            },
          },
          nextIconButton: {
            sx: {
              color: colors.text.primary,
            },
          },
          previousIconButton: {
            sx: {
              color: colors.text.primary,
            },
          },
        }}
        calendars={2}
        {...props}
      />
    </LocalizationProvider>
  );
}
